export const imageWrapperStyles = {
  width: "auto",
  height: { xs: 153, sm: 238 },
  maxWidth: 486,
  mx: "auto",
  boxSizing: "border-box",
  bgcolor: "background.default",
  borderRadius: "20px",
};

export const iconStyles = {
  width: { xs: 60, md: 100 },
  height: { xs: 60, md: 100 },
};
